module.exports = __webpack_public_path__ + "img/N115-2-EN.bbd0f553.png";